import React from 'react';
import styles from './ReviewFormLetter.module.css'
import TextDisplay from "../General/TextDisplay/TextDisplay";
import TopicCard from "../General/topicCard/topicCard";
import updateTopicsDictionary from "../../helper/updateTopicsDictionary";
import {getCommentTopicsAPI} from "../../api/commentAPI";
import {useSelector} from "react-redux";
import {updateTopicsAPI} from "../../api/reviewsAPI";
import {removeMCIdentificationsAPI} from "../../api/formLetterAPI";

const ReviewFormLetter = ({formLetter, changeNameFunc, stateFunc}) => {

    const jwt = useSelector((state) => state.user.jwt);
    const docket = useSelector((state) => state.navigation.currentDocket);

    const [name, setName] = React.useState("");
    const [selectedTopics, setSelectedTopics] = React.useState({});

    const updateSelectedTopics = (topic, subtopic, sentiment) => {
        updateTopicsAPI(jwt, docket, formLetter.parent[2], formLetter.parent[1], sentiment, topic, subtopic).then(r => {
            if (r.success) {
                let resp = updateTopicsDictionary(topic, subtopic, sentiment, selectedTopics);
                setSelectedTopics(resp)
            }
        })
    }

    const removeMCIdentifications = () => {
        if (window.confirm('Are you sure that you want to change all comments currently identified as group 1 or group 2 in this batch to Unknown (group 3)')) {
            removeMCIdentificationsAPI(jwt, docket, formLetter["batchID"]).then(r => {
                if (r.success) {
                    window.alert(`Successfully changed all group 1 and group 2 commenters in ${formLetter["name"]}`)
                } else {
                    window.alert('Error in changing group 1 and group 2 commenters.')
                }
            })
        }
    }

    React.useEffect(() => {
        setName(formLetter["name"])
    }, [formLetter])

    React.useEffect(() => {
        getCommentTopicsAPI(jwt, docket, formLetter.parent[2]).then(r => {
            if (r.success) {
                setSelectedTopics(r.data)
            }
        })
    }, [formLetter])

    return (
        <div className={styles.wrapper}>
            <div className={styles.textArea}>
                <TextDisplay trackingNum={formLetter["parent"][2]}
                             attachment={formLetter["parent"][1]} documentID={formLetter["parent"][0]}/>
            </div>

            <div className={styles.topicsArea}>
                <TopicCard selectedTopics={selectedTopics} toggleSelectedTopicFunc={updateSelectedTopics}/>
            </div>

            <div className={styles.nameArea}>
                <form action="" className={styles.form}>
                    <label className={styles.fieldLabel} id="nameLabel" htmlFor="flName">Form Letter Name:</label>
                    <input onChange={e => setName(e.currentTarget.value)} name={"flName"}
                           id={"flName"} className={styles.textField} type={"text"} value={name}/>
                    <button onClick={() => changeNameFunc(formLetter["batchID"], name)} type={"button"}>Change Name
                    </button>
                </form>
            </div>

            <div className={styles.commenterArea}>
                <button onClick={removeMCIdentifications} type={"button"}>Remove All MC Identifications</button>
            </div>

            <div className={styles.submitArea}>
                <button onClick={() => stateFunc(formLetter["batchID"], "Reviewed")}
                        className={formLetter["status"] === "Reviewing" ? styles.submit : undefined}
                        disabled={formLetter["status"] !== "Reviewing"}>
                    Mark Standard Review Complete
                </button>
                <button onClick={() => stateFunc(formLetter["batchID"], "Released")}
                        className={formLetter["status"] === "Reviewing" ? styles.release : undefined}
                        disabled={formLetter["status"] !== "Reviewing"}>
                    Release Batch for Review
                </button>
            </div>
        </div>
    );
};

export default ReviewFormLetter;